import {
    NOTIFICATIONS_SET_DATA,
    NOTIFICATIONS_RESET_DATA,
    NOTIFICATIONS_RESET_PAGINATION,
    NOTIFICATIONS_SET_PAGINATION,
    NOTIFICATIONS_SET_UNREAD_COUNT,
    NOTIFICATIONS_SET_ISLOADING,
    NOTIFICATIONS_SET_FILTERS,
} from '../actions/constants';
const initialPagination = {
    descendingOrder: true,
    nextOrPrev: 'first',
    currentPageNumber: 1,
    resultPerPage: 25,
};
const initialState = {
    pagination: initialPagination,
    data: [],
    unreadCount: 0,
    isLoading: false,
};
export default function (state = initialState, action) {
    switch (action.type) {
        case NOTIFICATIONS_RESET_DATA: return resetData(state);
        case NOTIFICATIONS_SET_DATA: return setData(action.data, state);
        case NOTIFICATIONS_RESET_PAGINATION: return resetPagination(state);
        case NOTIFICATIONS_SET_PAGINATION: return setPagination(action.data, state);
        case NOTIFICATIONS_SET_UNREAD_COUNT: return setUnreadCount(action.data, state);
        case NOTIFICATIONS_SET_ISLOADING: return setIsLoading(action.data, state);
        case NOTIFICATIONS_SET_FILTERS: return setFilters(action.data, state);
        default: return state;
    }
};
const resetData = (state) => {
    return {
        ...state,
        data: [],
    };
};
const setData = (data, state) => {
    return {
        ...state,
        data,
    };
};
const resetPagination = (state) => {
    return {
        ...state,
        pagination: initialPagination,
    };
};
const setPagination = (pagination, state) => {
    return {
        ...state,
        pagination: {
            ...state.pagination,
            ...pagination,
        },
    };
};
const setUnreadCount = (unreadCount, state) => {
    return {
        ...state,
        unreadCount,
    };
};
const setIsLoading = (isLoading, state) => {
    return {
        ...state,
        isLoading,
    };
};

const setFilters = (params, state) => {
    return {
        ...state,
        ...params,
        sourceObjectType: params.source || state.sourceObjectType,
    };
};